<template>
  <section class="card" :class="tone">
    <header class="head">
      <h3 class="title">{{ title }}</h3>
    </header>
    <div class="content">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    title: String,
    tone: { type: String, default: 'neutral' }, // neutral | success | info | danger
  },
};
</script>

<style scoped>
.card {
  border: 1px solid #e5e7eb;
  border-radius: var(--radius);
  background: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  padding: var(--card-pad);
}

.head {
  padding-bottom: 6px;
  border-bottom: 1px solid #eef0f3;
}
.title {
  font-weight: 800;
  /* Responsive header size similar to screenshot */
  font-size: clamp(16px, 1.35vw, 20px);
  color: #0f172a;
  margin: 0; /* prevent header vertical overflow */
}

.content {
  padding-top: 10px;
  font-weight: 600;
  /* Default body size inside card */
  font-size: clamp(14px, 1.1vw, 18px);
  line-height: 1.35;
  flex: 1 1 auto;
  min-height: 0; /* allow inner content to shrink */
  overflow: auto;
}

/* Ensure utility classes inside content also scale nicely */
.content :deep(.body-lg) {
  font-size: clamp(15px, 1.2vw, 18px);
}
.content :deep(.body-sm) {
  font-size: clamp(12px, 1.05vw, 14px);
}
@media (max-width: 780px) {
  .card {
    padding: calc(var(--card-pad) - 4px);
  }
  .title {
    font-size: clamp(16px, 4.5vw, 20px);
  }
  .content {
    padding-top: 6px;
  }
}

@media (max-height: 700px) {
  .head {
    padding: 8px 10px;
  }
  .content {
    padding: calc(var(--card-pad) - 4px);
  }
}

.success {
  background: #f0fdf4;
}
.info {
  background: #eff6ff;
}
.danger {
  background: #fee2e2;
}
</style>
